import Image from 'next/image'

import { Text } from '@wartek-id/text-v1'

import { SimpleCard } from 'app/KinerjaPSPegawaiPage/components/SimpleCard'

import type { FC } from 'react'

type CardJadwalDiskusiProps = {}

const CardJadwalDiskusi: FC<CardJadwalDiskusiProps> = () => {
  return (
    <div className="py-3">
      <SimpleCard className="select-none">
        <div className="flex items-center gap-6 p-6">
          <Image
            src="/illustrations/img-handshake.png"
            width={64}
            height={64}
            alt=""
          />

          <div>
            <Text variant="body-bold">
              Jadwalkan tanggal Diskusi Tindak Lanjut bersama Tim Kinerja di
              luar sistem
            </Text>
            <Text variant="body">
              Diskusi Tindak Lanjut dilakukan setelah pendampingan dan pengisian
              Anda di atas selesai.
            </Text>
          </div>
        </div>
      </SimpleCard>
    </div>
  )
}

export default CardJadwalDiskusi
